export function superviseIntervention({
  decision,
  prediction,
  adaptive,
  lastActionTime,
}) {
  if (!decision) return null;

  const now = Date.now();
  const delay =
    lastActionTime ? (now - lastActionTime) / 1000 : null;

  // escalation logic
  if (decision.level === "CRITICAL") {
    if (!lastActionTime) {
      return {
        stage: "awaitingOperator",
        message: "operatorAckRequired",
      };
    }

    if (delay > 30) {
      return {
        stage: "autoEscalation",
        message: "escalatingEmergency",
      };
    }
  }

  if (prediction?.earlyWarning && adaptive?.escalateFaster) {
    return {
      stage: "preemptiveAlert",
      message: "escalationAccelerated",
    };
  }

  return {
    stage: "monitoring",
    message: "systemObserving",
  };
}
